import { CONTRATO_TIPO_ASSESSOR_NAME } from '../../library/ContratoTipos';
import { CONTRATO_VERSAO_CONTRATO } from '../../library/ContratoVersoes';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { getNumberOfCurrencyStr } from '../../utils/InputMaskUtils';
import {
  LOADED_CONTRATO_ANALISE_OPERACIONAL,
  LOADING_CONTRATO_ANALISE_OPERACIONAL,
} from './ContratosActions';
import {
  CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION,
  CLEAR_COD_COOP_ACTION,
  CLEARED_CONTRATO_ASSESSOR_ACTION,
  LOADED_CONTRATO_ASSESSOR_ACTION,
  LOADED_CONTRATO_ASSESSOR_ARQUIVOS,
  LOADED_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
  LOADED_CONTRATO_VALIDACAO,
  LOADING_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION,
  LOADING_CONTRATO_ASSESSOR_ARQUIVOS,
  LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL,
} from './ContratosAssessoresActions';

const CONTRATO_EDITING_NOT_NULL_PROPS = [
  'emailCoop',
  'codCoop',
  'cpfAssessor',
  'dataDistrato',
  'dataFim',
  'dataInicio',
  'reembolso',
  'htmlContrato',
  'programasEducacionais',
  'templateContrato',
  'observacoesReembolso',
  'valorReembolsoHospedagem',
  'valorReembolsoAlimentacao',
  'valorReembolsoDeslocamento',
  'valorReembolsoPedagio',
  'valorReembolsoOutros',
  'reembolsoOutrosDescricao',
  'reembolsoObservacoes',
  'flgAnaliseJuridica',
];

const CONTRATO_EDITING_INITIAL_STATE = {
  emailCoop: '',
  idContrato: null,
  idAditivo: null,
  idDistrato: null,
  codCoop: '',
  cpfAssessores: [],
  dataDistrato: '',
  dataFim: '',
  dataInicio: '',
  flgAnaliseJuridica: false,
  totalMeses: 0,
  idEmpresa: 0,
  programasEducacionais: [],
  versaoContrato: CONTRATO_VERSAO_CONTRATO,
  valorAssessoriaEnabled: false,
  valorAssessoria: 0,
  valorFormacaoEnabled: false,
  valorFormacao: 0,
  valorOutrosEnabled: false,
  valorOutros: 0,
  valorReuniaoEnabled: false,
  valorReuniao: 0,
  flgStatus: -1,
  ativo: true,
  htmlContrato: '',
  templateContrato: '',
  historicoAnaliseOperacional: [],
  arquivos: null,
  reembolsoHospedagemEnabled: false,
  reembolsoAlimentacaoEnabled: false,
  reembolsoDeslocamentoEnabled: false,
  reembolsoPedagioEnabled: false,
  reembolsoOutrosEnabled: false,
  valorReembolsoHospedagem: null,
  valorReembolsoAlimentacao: null,
  valorReembolsoDeslocamento: null,
  valorReembolsoPedagio: null,
  valorReembolsoOutros: null,
  reembolsoOutrosDescricao: '',
  observacoesReembolso: '',
};

const INITIAL_STATE = {
  loadingArquivos: false,
  loadingAlteraArquivo: false,
  loadingAlteraStatus: false,
  loadingHtmlContrato: false,
  loadingTemplateContrato: false,
  loadingHistoricoAnaliseOperacional: false,
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
};

const getWithValorHoraFlags = (contrato) => {
  let newContrato = { ...contrato };
  const valorAssessoria = !newContrato.valorAssessoria
    ? 0
    : getNumberOfCurrencyStr(newContrato.valorAssessoria, ',');
  const valorFormacao = !newContrato.valorFormacao
    ? 0
    : getNumberOfCurrencyStr(newContrato.valorFormacao, ',');
  const valorOutros = !newContrato.valorOutros
    ? 0
    : getNumberOfCurrencyStr(newContrato.valorOutros, ',');
  const valorReuniao = !newContrato.valorReuniao
    ? 0
    : getNumberOfCurrencyStr(newContrato.valorReuniao, ',');
  const valorReembolsoHospedagem =
    newContrato.valorReembolsoHospedagem === null
      ? null
      : getNumberOfCurrencyStr(newContrato.valorReembolsoHospedagem, ',');
  const valorReembolsoAlimentacao =
    newContrato.valorReembolsoAlimentacao === null
      ? null
      : getNumberOfCurrencyStr(newContrato.valorReembolsoAlimentacao, ',');
  const valorReembolsoDeslocamento =
    newContrato.valorReembolsoDeslocamento === null
      ? null
      : getNumberOfCurrencyStr(newContrato.valorReembolsoDeslocamento, ',');
  const valorReembolsoPedagio =
    newContrato.valorReembolsoPedagio === null
      ? null
      : getNumberOfCurrencyStr(newContrato.valorReembolsoPedagio, ',');
  const valorReembolsoOutros =
    newContrato.valorReembolsoOutros === null
      ? null
      : getNumberOfCurrencyStr(newContrato.valorReembolsoOutros, ',');

  if (valorAssessoria && valorAssessoria > 0) {
    newContrato.valorAssessoriaEnabled = true;
  }
  if (valorFormacao && valorFormacao > 0) {
    newContrato.valorFormacaoEnabled = true;
  }
  if (valorOutros && valorOutros > 0) {
    newContrato.valorOutrosEnabled = true;
  }
  if (valorReuniao && valorReuniao > 0) {
    newContrato.valorReuniaoEnabled = true;
  }
  if (valorReembolsoHospedagem !== null) {
    newContrato.reembolsoHospedagemEnabled = true;
  } else {
    newContrato.reembolsoHospedagemEnabled = false;
  }
  if (valorReembolsoAlimentacao !== null) {
    newContrato.reembolsoAlimentacaoEnabled = true;
  } else {
    newContrato.reembolsoAlimentacaoEnabled = false;
  }
  if (valorReembolsoDeslocamento !== null) {
    newContrato.reembolsoDeslocamentoEnabled = true;
  } else {
    newContrato.reembolsoDeslocamentoEnabled = false;
  }
  if (valorReembolsoPedagio !== null) {
    newContrato.reembolsoPedagioEnabled = true;
  } else {
    newContrato.reembolsoPedagioEnabled = false;
  }
  if (valorReembolsoOutros !== null) {
    newContrato.reembolsoOutrosEnabled = true;
  } else {
    newContrato.reembolsoOutrosEnabled = false;
  }
  return newContrato;
};

export default function ContratosAssessoresReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case CLEARED_CONTRATO_ASSESSOR_ACTION:
      return { ...state, contratoEditing: CONTRATO_EDITING_INITIAL_STATE };
    case CLEAR_COD_COOP_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          codCoop: '',
        },
      };
    case LOADED_CONTRATO_ASSESSOR_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...getWithValorHoraFlags({
            ...action.payload,
            historicoAnaliseOperacional: CONTRATO_EDITING_INITIAL_STATE.historicoAnaliseOperacional,
          }),
          ...CONTRATO_EDITING_NOT_NULL_PROPS
        },
      };
    case CHANGED_CONTRATO_ASSESSOR_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...getWithValorHoraFlags({
            ...state.contratoEditing,
            [action.payload.name]: action.payload.value,
          }),
          ...CONTRATO_EDITING_NOT_NULL_PROPS
        },
      };
    case LOADED_CONTRATO_VALIDACAO:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          htmlContrato: action.payload,
        },
      };
    case LOADING_CONTRATO_ANALISE_OPERACIONAL:
      if (action.payload.tipoContrato === CONTRATO_TIPO_ASSESSOR_NAME) {
        return { ...state, loadingTemplateContrato: action.payload.loading };
      }
      return state;
    case LOADED_CONTRATO_ANALISE_OPERACIONAL:
      if (action.payload.tipoContrato === CONTRATO_TIPO_ASSESSOR_NAME) {
        return {
          ...state,
          contratoEditing: transformNullIntoEmpty(
            {
              ...state.contratoEditing,
              templateContrato: action.payload.template,
            },
            CONTRATO_EDITING_NOT_NULL_PROPS
          ),
        };
      }
      return state;
    case LOADING_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL:
      return { ...state, loadingHistoricoAnaliseOperacional: action.payload };
    case LOADED_CONTRATO_ASSESSOR_HISTORICO_ANALISE_OPERACIONAL:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            historicoAnaliseOperacional: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ASSESSOR_ARQUIVOS:
      return { ...state, loadingArquivos: action.payload };
    case LOADED_CONTRATO_ASSESSOR_ARQUIVOS:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            arquivos: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ASSESSOR_ALTERA_STATUS_ACTION:
      return {
        ...state,
        loadingAlteraStatus: action.payload,
        loadingAlteraArquivo: action.payload,
      };
    default:
      return state;
  }
}
